module.exports = __webpack_public_path__ + "static/media/shohelrana-baig.5222b5c9.jpg";